import { useQuery } from '@apollo/client/react';

import { gql } from 'src/__generated__';

export const GET_PROFILE_ANALYTIC = gql(`
  query GetProfileAnalytic {
    viewer {
      _id
      profileVisibility {
        level
      }
      shareableProfileSettings {
        url
        active
      }
      approachability {
        approachable
      }
    }
  }
`);

const getProfileSharedStatus = (url: string, active: boolean) => {
  if (!Boolean(url)) {
    return 'not generated';
  }
  if (active) {
    return 'on';
  }
  return 'off';
};

export const useProfileAnalytic = () => {
  const { data } = useQuery(GET_PROFILE_ANALYTIC);

  const approachable =
    data?.viewer?.approachability?.approachable === null
      ? true
      : data?.viewer?.approachability?.approachable;
  const profileApproachabilityStatus = approachable ? 'on' : 'off';

  const url = data?.viewer?.shareableProfileSettings?.url || '';
  const active = data?.viewer?.shareableProfileSettings?.active || false;
  const profileSharedStatus = getProfileSharedStatus(url, active);

  const profileVisibilityLevel =
    data?.viewer?.profileVisibility?.level.toLowerCase() || 'not set';

  return {
    profileApproachabilityStatus,
    profileSharedStatus,
    profileVisibilityLevel,
  };
};
